import { Injectable } from '@angular/core';
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import { OperationSummaryComponent } from '../../components/international-operation-summary/operation-summary.component';
import { SummaryPaymentModel } from '../../components/international-operation-summary/summaryPaymentModel';

@Injectable({
  providedIn: 'root'
})
export class InternationalOperationSummaryService {

  private modalRef!: NgbModalRef;

  constructor(private modalService: NgbModal, private modalConfig: NgbModalConfig) {
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;
  }

  open(summaryPayment: SummaryPaymentModel) {
    this.modalRef = this.modalService.open(OperationSummaryComponent);
    this.modalRef.componentInstance.summaryPayment = summaryPayment;
  }
}
